import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, UrlSerializer } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AxAuthenticationModule } from '@atlasx/core/authentication';
import { AxConfigurationModule } from '@atlasx/core/configuration';
import {
    AxHttpServiceModule,
    AxWebServiceUrl,
} from '@atlasx/core/http-service';
import esriConfig from '@arcgis/core/config';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE, NativeDateModule } from '@angular/material/core';
import { StoreModule } from './store/store.module';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { File } from '@ionic-native/file/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';
import {
    environment,
    APP_BMA_TAXMAP_URL_PREFIX,
    APP_BMA_PROXY_URL,
    APP_WEBSITE_NAME,
} from '../environments/environment';

import * as urlUtils from '@arcgis/core/core/urlUtils';
import { CookieService } from 'ngx-cookie-service';
import { CookieComponent } from './components/layout/cookie/cookie.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import CustomUrlSerializer, {
    EncodeHttpParamsInterceptor,
} from './services/custom-encode.service';

esriConfig.assetsPath = `${document.baseURI}assets`;
urlUtils.addProxyRule({
    urlPrefix: APP_BMA_TAXMAP_URL_PREFIX,
    proxyUrl: APP_BMA_PROXY_URL,
});
@NgModule({
    declarations: [AppComponent, SidebarComponent, CookieComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        /** IonicModule.forRoot({ swipeBackEnabled: false }) */
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        IonicModule.forRoot({
            // mode: 'ios',
            scrollAssist: false,
            scrollPadding: false,
        }),
        BrowserAnimationsModule,
        NativeDateModule,
        StoreModule,
        HttpClientModule,
        // LayoutModule,
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // {
        //     provide: AxWebServiceUrl,
        //     useValue: 'https://atlasx.cdg.co.th/axws-demo',
        // },
        // StatusBar,
        File,
        FileOpener,
        InAppBrowser,
        DatePipe,
        Deeplinks,
        LocalNotifications,
        CookieService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EncodeHttpParamsInterceptor,
            multi: true,
        },
        { provide: MAT_DATE_LOCALE, useValue: 'th-TH' },
        { provide: APP_BASE_HREF, useValue: `/${APP_WEBSITE_NAME}` },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
